import { StyleSheet } from 'react-native'
import { Fonts, Colors } from '@vfgroup-oneplatform/foundation/Components/Themes'

const styles = StyleSheet.create({
  card: {
    flex: 1,
    marginTop: 16,
    borderRadius: 5,
    paddingVertical: 16
  },
  paddingHorizontal: {
    paddingHorizontal: 16
  },
  installationStep: {
    paddingVertical: 32
  },
  header: {
    marginBottom: 16,
    fontWeight: 'bold',
    fontSize: Fonts.size.h4
  },
  description: {
    fontSize: 16,
    lineHeight: 19,
    letterSpacing: 0.2
  },
  selectedDayContainer: {
    borderRadius: 50,
    backgroundColor: '#007C92'
  },
  selectedDayText: {
    color: 'white'
  },
  feeHolder: theme => ({
    marginTop: 18,
    marginBottom: 32,
    paddingVertical: 42,
    paddingHorizontal: 16,
    borderRadius: 5,
    backgroundColor: theme.colors.cardBackgroundColor
  }),
  flex: {
    display: 'flex',
    paddingBottom: 16,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between'
  },
  feeTitle: {
    fontSize: 24,
    fontWeight: 'bold'
  },
  feeSubtitle: {
    fontSize: 16,
  },
  feeDivider: {
    marginBottom: 16,
    borderBottomWidth: 1,
    borderBottomColor: '#EBEBEB'
  },
  feeLabel: {
    fontSize: 16
  },
  feeValue: {
    fontSize: 16,
    fontWeight: 'bold'
  },
  feeDescription: {
    fontSize: 14,
    lineHeight: 15
  },
  calendar: {
    borderRadius: 5
  },
  calendarWrapper: {
    paddingHorizontal: 16,
    marginTop: 32,
  },
  preferTime: {
    fontSize: 18,
    paddingTop: 32,
    paddingBottom: 24
  },
  roundedBorders: {
    borderRadius: 6,
    overflow: 'hidden'
  },
  selectedPlan: {
    borderWidth: 2,
    borderColor: Colors.blue_two
  },
  optionWrapper: {
    borderWidth: 1,
    borderColor: Colors.warm_grey_two
  },
  verticalPadding: { padding: 12 },
  bgWhite: theme => ({
    backgroundColor: theme.colors.cardBackgroundColor
  }),
  timeOfDay: { fontSize: 18 }
})

export default styles
